module.exports = __webpack_public_path__ + "static/news-1-3cad81ac608710e96d7c0956201c05e4.png";